<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-for="(item,index) in list" :key="index" :to="{'path': item.path}" >{{item.title}}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>


<style scoped>
</style>

<script>
export default {
    name:"Breadcrumb",
    data() {
        return {
            list: [],
        }
    },
    created() {
       this.getBreadcrumb();
    },
    methods: {
        getBreadcrumb() {         
               
            let matched = this.$route.matched;
            //判断是不是有首页
            if(this.$route.path != '/home') {
                this.list.push({"title": this.$i18n.t('menu.home'),"path": "/home"})
            }
            matched.forEach(element => {
                if(element.meta.parent != null && element.meta.parentPath != null){
                    this.list.push({"title": this.$i18n.t(element.meta.parent), "path":element.meta.parentPath })
                }else if(element.meta.parent != null && element.meta.parentPath == null){
                    this.list.push({"title":this.$i18n.t(element.meta.parent) })
                }
                this.list.push({"title":this.$i18n.t(element.meta.title),"path": element.path})
            }); 
        }
    },
}
</script>